class t {
  productCode;
  nameVariation;
  enabled;
  constructor(e, a) {
    this.productCode = e, this.nameVariation = a, this.enabled = !0;
  }
  static Default() {
    return new t(void 0, void 0);
  }
  static Disabled() {
    const e = t.Default();
    return e.enabled = !1, e;
  }
}
export {
  t as MetadataOptions
};
//# sourceMappingURL=index.js.map
